import React from "react";

export default function () {
    return (
        <div>
            There are no responses for now.
        </div>
    )
}